import { sample } from 'lodash';

import type { ActionContext } from 'js/lib/ActionContext';

type Payload = Record<string, unknown>;

const AVAILABLE_FEATURED_PARTNER_IDS = [
  47, 79, 65, 50, 77, 104, 7, 4, 62, 56, 12, 36, 71, 64, 3, 9, 16, 51, 54, 30, 26, 34, 49,
];

function getRandomFeaturedPartnerId() {
  return sample(AVAILABLE_FEATURED_PARTNER_IDS);
}

const exported = {
  chooseFeaturedPartner: (actionContext: ActionContext, payload?: Payload) => {
    let { featuredPartnerId } = actionContext.getStore('PartnersStore');
    if (!featuredPartnerId) {
      featuredPartnerId = getRandomFeaturedPartnerId();
      actionContext.dispatch('RECEIVE_FEATURED_PARTNER_ID', featuredPartnerId);
    }
    return featuredPartnerId;
  },
};

export default exported;

export const { chooseFeaturedPartner } = exported;
